import React, { useEffect, useState, useCallback } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import multiMonthPlugin from '@fullcalendar/multimonth';
import esLocale from '@fullcalendar/core/locales/es';
import { Alert, Col, Row, Container, Card, ListGroup, Breadcrumb } from 'react-bootstrap';
import moment from 'moment';
import toastr from 'toastr';

import CustomNavbar from '../../../components/CustomNavbar';
import SidebarDashboard from '../../../components/SidebarDashboard';
import CalendarAddEvent from './CalendarAddEvent';
import { useSelector, useDispatch } from "react-redux";
import "../../../css/calendar.css"
import { eventTypes } from './eventTypes';
import {
  getEmployeeCalendarEvents,
  updateEmployeeCalendarEvent
} from "../../../redux/vacations/calendar_employee_events/actions";
import UserProfileAvatar from '../../../components/vacations/calendar/UserProfileAvatar';
import AsideListItem from '../../../components/vacations/calendar/AsideListItem';
import AsideColorLegend from '../../../components/vacations/calendar/AsideColorLegend';
import userPerfilImg from '../../../images/userperfil.png';
import HeaderWithSearchForm from '../../../components/header_with_search_form/HeaderWithSearchForm';

const Calendar = (props) => {

  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditform, setIsEditform] = useState(false);
  const [formInitialData, setFormInitialData] = useState({});
 
  const {
    isLoadingEmployeeCalendarEvents,
    employeeCalendarEventsFail,
    calendarEmployeeEvents
  } = useSelector((store) => store.calendarEmployeeEvents);

  const dispatch = useDispatch();

  const getCalendarEvents = useCallback((username=props.match.params.username) => {
    dispatch(getEmployeeCalendarEvents({
      filter: {
        empleado__codigo: username
      }
    }));
  }, [dispatch, props.match.params.username]);
  
  useEffect(() => {
    getCalendarEvents()
  }, [getCalendarEvents]);

  // const isSunday = (day) => {
  //   const weekDay = moment(day).day();
  //   return weekDay === 0;
  // }

  const onDateClick = (info) => {
    const selectedDate = info.dateStr;
    const holiday = calendarEmployeeEvents && calendarEmployeeEvents.eventsData ? calendarEmployeeEvents.eventsData.find(h => h.start === info.dateStr) : null;
    if (holiday && holiday.extendedProps.type === 'feriado') {
      toastr.error("No se pueden planificar vacaciones, tiempo compesatorio u horas libres los domingos");
      return;
    }
    setFormInitialData({ employee_code: props.match.params.username, start: selectedDate, end: selectedDate });
    setIsEditform(false);
    setShowModal(true);
  }

  const onEventClick = (info) => {
    const event = info.event;
    const eventStart = moment(event.start).format("YYYY-MM-DD");
    const eventEnd = moment(event.end).subtract(1, "day").format("YYYY-MM-DD");

    if (!event.id) {
      const holiday = calendarEmployeeEvents?.eventsData?.find(h => h.start === eventStart);
      if (holiday?.extendedProps.type === 'feriado') {
        //toastr.error("No se pueden planificar vacaciones, tiempo compesatorio u horas libres los domingos");
        return;
      }
    }

    setFormInitialData({
      id: event.id,
      employee_code: props.match.params.username,
      start: eventStart,
      end: eventEnd,
      title: event.title,
      location: event.extendedProps.location,
      notes: event.extendedProps.notes,
      type: event.extendedProps.type
    });
    setIsEditform(true);
    setShowModal(true);
  };

  const containsHoliday = (startDate, endDate) => {
    if (!calendarEmployeeEvents || !calendarEmployeeEvents.eventsData) return false;

    const holidays = calendarEmployeeEvents.eventsData.filter(h => h.extendedProps.type === 'feriado');
    return holidays.some(h => moment(h.start).isBetween(startDate, endDate, null, '[]'));
  }

  const handleEventDrop = (info) => {
    const { view } = info;
    if (view.type === 'timeGridWeek' || view.type === 'timeGridDay') {
      info.revert();
    } else {
      let startDate = moment(info.event.start).format("YYYY-MM-DD")
      let endDate = moment(info.event.end).subtract(1, "day").format("YYYY-MM-DD")

      if (containsHoliday(startDate, endDate)) {
        toastr.error("No se pueden planificar vacaciones, tiempo compesatorio u horas libres los domingos");
        info.revert();
        return
      }
      let req = {
        id: info.event.id,
        title: info.event.title,
        start_date: startDate,
        end_date: endDate,
        location: info.event.extendedProps.location,
        notes: info.event.extendedProps.notes,
        type: info.event.extendedProps.type,
        codigo_empleado: props.match.params.username
      }
      dispatch(updateEmployeeCalendarEvent(req.id, req));
    }
  };

  const onEventResize = (info) => {
    const { view } = info;
    if (view.type === 'timeGridWeek' || view.type === 'timeGridDay') {
      info.revert();
    } else {
      let startDate = moment(info.event.start).format("YYYY-MM-DD")
      let endDate = moment(info.event.end).subtract(1, "day").format("YYYY-MM-DD")

      if (containsHoliday(startDate, endDate)) {
        toastr.error("No se pueden planificar vacaciones, tiempo compesatorio u horas libres los domingos");
        info.revert();
        return
      }
      let req = {
        id: info.event.id,
        title: info.event.title,
        start_date: startDate,
        end_date: endDate,
        location: info.event.extendedProps.location,
        notes: info.event.extendedProps.notes,
        type: info.event.extendedProps.type,
        codigo_empleado: props.match.params.username
      }
      dispatch(updateEmployeeCalendarEvent(req.id, req));
    }
  }

  const handleAddEvent = () => {
    setFormInitialData({ employee_code: props.match.params.username });
    setIsEditform(false)
    setShowModal(true)
  }

  const onShowSidebar = () => setShow(show ? false : true);

  const onSearch = (e) => {
    e.preventDefault();
    getCalendarEvents(e.target.search.value);
  }

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {employeeCalendarEventsFail && (
            <Alert variant="danger" className={"mt-3 mb-3 mx-3"}>
              {employeeCalendarEventsFail}
            </Alert>
          )}
          <Breadcrumb className="mb-3">
            <Breadcrumb.Item href="/saldo-vacaciones">Saldo de vacaciones</Breadcrumb.Item>
            <Breadcrumb.Item active>Planificador de eventos</Breadcrumb.Item>
          </Breadcrumb>
          <div className="mb-3">  
            <HeaderWithSearchForm 
              onSearch={onSearch} 
              title="Programar eventos"
              showNewRecordButton={true}
              onAdd={handleAddEvent} />
          </div>
          <section>
            <Row>
              <Col as="aside" md={3} sm={12}>
                <Card className="mb-2">
                  <Card.Body>
                    <UserProfileAvatar 
                      profileImgUrl={calendarEmployeeEvents?.userData?.foto ? `${process.env.REACT_APP_URL}${calendarEmployeeEvents.userData.foto}` : userPerfilImg}
                      name={calendarEmployeeEvents?.userData?.nombre || "Michael B Jordan"} 
                      jobFunc={calendarEmployeeEvents?.userData?.puesto || "Director de Recursos Humanos"} />
                  </Card.Body>
                </Card>
                <h6 className='pl-1 mb-1'>Vacaciones</h6>
                <ListGroup className="mb-2">
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Disponibles || 0} text={"Disponibles"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Disfrutados || 0} text={"Disfrutados"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Pendientes || 0} text={"Pendientes"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Programados || 0} text={"Programado"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Cumplimiento || 0} text={"Cumplimiento"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Total || 0} text={"Total"} />
                </ListGroup>
                <h6 className='pl-1 mb-1'>Tiempos compensatorios</h6>
                <ListGroup className="mb-2">
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_disponible || 0} text={"Disponibles"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_restante || 0} text={"Pendientes"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_programados || 0} text={"Programado"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_cumplimiento || 0} text={"Cumplimiento"} />
                </ListGroup>
                <Card>
                  <Card.Body>
                    {
                      (Object.values(eventTypes)).map(({ name, color }, index) => ( 
                        <AsideColorLegend key={index} color={color} name={name} />
                      ))
                    }
                  </Card.Body>
                </Card>
              </Col>
              <Col as="main" md={9} sm={12}>
                <Card>
                  <Card.Body>
                    <FullCalendar
                      loading={isLoadingEmployeeCalendarEvents}
                      plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin, multiMonthPlugin]}
                      initialView="multiMonthYear"
                      headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay'
                      }}
                      weekends={true}
                      multiMonthMinWidth={2}
                      locales={[esLocale]}
                      locale={'es'}
                      events={calendarEmployeeEvents?.eventsData || []}
                      editable={true}
                      eventDrop={handleEventDrop}
                      businessHours={[
                        {
                          // Set the business hours here
                          daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
                          startTime: '08:00',
                          endTime: '17:00',
                        },
                        {
                          daysOfWeek: [6], // saturday
                          startTime: '08:00',
                          endTime: '12:00',
                        }]}
                      dateClick={onDateClick}
                      eventClick={onEventClick}
                      eventResize={onEventResize} />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </section>
          <CalendarAddEvent
            avaibleVac={calendarEmployeeEvents?.kpiEvents?.Disponibles || 0}
            avaibleCT={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_disponible || 0}
            isEditForm={isEditform} 
            setShowModal={setShowModal} 
            showModal={showModal} 
            formInitialData={formInitialData} 
            eventTypes={eventTypes} />
        </Container>
      </div>
    </>
  )
}

export default Calendar